import { Outlet } from 'react-router';

export default function LocaleLayout() {
  return <Outlet />;
}
